import axios from 'axios';
import { getParamSerializerForAxiosVersion1or0 } from './ApiUtil';
const ShopAPI = (teliaShopUrl) => {
    return axios.create({
        baseURL: `${teliaShopUrl || 'https://pood.telia.ee'}/api`,
        timeout: 30000,
        paramsSerializer: getParamSerializerForAxiosVersion1or0(),
        withCredentials: true,
    });
};
export default ShopAPI;
